<template>
	<a class="google float-left flex justify-center round" alt="Sign Up Using Google Auth" @click="signInWithPopUp()">
		<img :src="google_logo" width="50" alt="Google Logo">
	</a>
</template>

<script>

	// Import firebase services
	import firebase from 'firebase/app'
    import { firebaseAuth, usersModel } from '@/firebase/firebase-config'

	// Import the mixins
	import { BugsnagService } from '@/mixins/services/bugsnag/BugsnagService'
	import { UsersRepository } from '@/components/mixins/repositories/users/UsersRepository'
	import { SpinnerMethods } from '@/mixins/helpers/SpinnerMethods'
	import { GenerateUID } from '@/mixins/helpers/GenerateUID'
	
	export default {

		/*
		** Set the component name
		*/

		name: 'GoogleAuthRegisterButton',

		/*
		**  Register the mixins
		*/

		mixins: [

			BugsnagService,
			UsersRepository,
			SpinnerMethods,
			GenerateUID

		],

		/*
		**  Set up the data
		*/

		data: () => ({

			google_logo: 'https://firebasestorage.googleapis.com/v0/b/nestd-prod.appspot.com/o/logos%2Fgoogle-logo.svg?alt=media&token=76d68910-8e2a-4dfe-8015-7af814084341',
			google_access_token: null,
			google_user: null,
			google_provider: null,
			first_name: null,
			last_name: null,
			existing_user: false

		}),

		/*
		**  Set up the methods
		*/

		methods: {

			setGoogleProvider: function() {

				this.google_provider = new firebase.auth.GoogleAuthProvider();

			},

			signInWithPopUp: function() {

				// Set the provider
				this.setGoogleProvider();

				// Trigger pop up
				firebaseAuth.signInWithPopup(this.google_provider)
				.then(function(result) {

					// Get the access token
					if (result.credential) {

						// Set the API creds
						this.google_access_token = result.credential.accessToken;

					}

					// Store the data
					this.google_user = result.user;

				}.bind(this))
				.then(() => {

					// Check if user exists
					if (this.google_user) this.userCheck();

				})
				.catch(function(error) {

					// Throw error message
					this.$swal('Uh Oh!', 'Looks like we ran into the following issue when signing you in. More details: ' + error.message, 'error');

					// Send to bugsnag
					this.reportCustomBugsnagError({
						title: 'SISU - Google Auth Sign Up With Pop Up',
						errorType: 'Firebase Auth',
						section: 'SISU',
						component: 'GoogleAuthRegisterButton',
						error: error,
						custom: {
							errorCode: error.code,
							errorMessage: error.message,
							userEmail: error.email,
							credentialType: error.credential
						}
					});

				}.bind(this));

			},

			userCheck: function() {

				// Get the user doc
				usersModel.doc(this.google_user.uid).get()
				.then(doc => {

					if (!doc.exists) {

						// Create a new user
						if (this.google_user) {

							// Set the new user object
							this.setNewUser();

							// Create the user record
							this.createUser(this.google_user.uid);

						}

						return;
					};

					// Set the prop
					this.existing_user = true;

					// Throw warning message
					this.$swal('Uh Oh!', 'Looks like you have already created an account with us. Please sign in.', 'error');

				})
				.catch(error => {

					// Send to bugsnag
					this.reportNoAuthBugsnagError({
						title: 'SISU - Google Sign Up User Check',
						errorType: 'Firestore Database',
						section: 'SISU',
						component: 'GoogleAuthRegisterButton',
						error: error
					});

				});

			},

			slugifyTheSlug: function() {

				// Set the slug - slugify - main.js
				this.new_user.attributes.profile.slug = slugify(this.slugifiedSlug, {
					replacement: '_',
					remove: /[*+~.()'"!:@]/g,
					lower: true,
				});

				// Add slug as username
				this.new_user.attributes.profile.username = this.new_user.attributes.profile.slug;

				// Add UID to it to make unique
				this.new_user.attributes.profile.slug = this.new_user.attributes.profile.slug + '_' + this.generateUID();

			},

			setNewUser: function() {

				// Split the names
				let splitDisplayName = this.google_user.displayName.split(' ');

				// Assign the name values
				if (splitDisplayName.length > 0) this.first_name = splitDisplayName[0];
				if (splitDisplayName.length > 1) this.last_name = splitDisplayName[1];

				// Set the props
				this.new_user.attributes.profile.email = this.google_user.email;
				this.new_user.attributes.profile.first_name = this.first_name;
				this.new_user.attributes.profile.last_name = this.last_name;
				this.new_user.relationships.google.access_token = this.google_access_token;
				this.new_user.id = this.google_user.uid;

				// Set avatar prop
				if(this.google_user.photoURL) this.new_user.links.avatar = this.google_user.photoURL;

				// Set the terms and agreement
				this.new_user.attributes.terms_agreement.opted_in = true;

				// Set the slug
				this.slugifyTheSlug();

			}

		},

		/*
		**  Set up the computed props
		*/

		computed: {

			slugifiedSlug: function() {

				return this.new_user.attributes.profile.first_name + ' ' + this.new_user.attributes.profile.last_name;

			}

		}

	}

</script>